import Callout from '@/components/Callout';
import { IconCategories, IconPlus } from '@/theme/icons';
import rem from '@/utils/rem';
import { Icon, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const EmptyCategoryCallout = () => {
  const { t } = useTranslation('EmptyCategoryCallout');
  return (
    <Callout title={t('title.emptyCategoriesTitle')} backgroundColor="background-tertiary">
      <Text textStyle="small">
        {t('instructions.createAction')}{' '}
        <Icon
          as={IconPlus}
          verticalAlign="middle"
          width={rem(22)}
          height={rem(22)}
          padding={rem(4)}
          color="text-primary"
          borderWidth={rem(1)}
          borderStyle="solid"
          borderColor="gray.700"
          borderRadius={rem(4)}
          marginX={rem(4)}
        />{' '}
        {t('instructions.inCategoryWantToAdd')}
      </Text>
      <Text
        sx={{
          'span:not(.block)': {
            opacity: '0.5',
          },
          '.block': {
            display: 'inline-flex',
            gap: rem(4),
            verticalAlign: 'top',
            marginRight: rem(8),
          },
        }}
        textStyle="small"
        marginTop={rem(14)}
        color="text-secondary"
      >
        <span>{t('instructions.createCategory')}</span>
        <Icon as={IconPlus} boxSize={rem(14)} verticalAlign="middle" marginX={rem(4)} />
        <span style={{ marginRight: rem(8) }}>{t('instructions.underCircles')}</span>
        <span className="block">
          <Icon as={IconCategories} boxSize={rem(14)} /> {t('instructions.categories')}
        </span>
        <span>{t('instructions.inHeader')}</span>
      </Text>
    </Callout>
  );
};

export default EmptyCategoryCallout;
